"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeStyleSheets = serializeStyleSheets;
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map((cssStyleSheet) => {
        const rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        const cssRules = Array.from(rules, (cssRule) => cssRule.cssText);
        const styleSheet = {
            cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map